import { useContext } from 'react';
import tcContext from '@/contexts/tcContext';
import { ITCContext } from '@/types/tc';

const useTC = (): ITCContext | null => useContext(tcContext);

export default useTC;
